{
    "header_tab__STORAGE_LOCATION": "Storage Location",
    "header_tab__CLERK": "Clerk",
    "header_tab__SALES_REP": "Sales Rep",
    "header_tab__CUSTOMER": "Customer",
    "header_tab__INDUSTRY": "Industry",
    "header_tab__PRODUCT": "Product",
    "header_tab__PRODUCT_GROUP": "Product Group",
    "header_tab__SUPPLIER": "Supplier",
    "header_tab__NORMALISED_CATEGORY": "Merchandise Group",
    "filter_dropdown_status__label": "Metric",
    "filter_dropdown_status__billed": "Revenue",
    "filter_dropdown_status__billed_wo_credit_note": "Revenue (without credit notes)",
    "filter_dropdown_status__unbilled": "Unbilled Revenue",
    "filter_dropdown_status__order_sum": "Order Sum",
    "filter_dropdown_unit__label": "Unit",
    "filter_dropdown_unit__monetary": "Value",
    "filter_dropdown_unit__units": "Units",
    "filter_dropdown__period_label": "Periods",
    "filter_dropdown__period": "{{years}} Periods",
    "radio_option__revenue": "Revenue",
    "radio_option__margin": "Revenue Margin",
    "radio_option__order_sum": "Order Sum",
    "radio_option__order_sum_margin": "Order Sum Margin",
    "table_label__revenue_spark_chart": "Revenue Last 24 months",
    "table_label__order_sum_spark_chart": "Order Sum Last 24 months",
    "table_label__unbilled_spark_chart": "Unbilled Revenue Last 24 months",
    "table_label__billed_wo_credit_note_spark_chart": "Revenue excl. credit notes Last 24 months",
    "table_label__units_spark_chart": "Units Last 24 months",
    "table_label__order_count_spark_chart": "Orders Last 24 months",
    "table_label__units_current": "Units",
    "table_label__units_last_period": "Units Previous Year",
    "table_label__units_delta_amount": "Delta",
    "table_label__units_delta_percentage": "Delta %",
    "table_label__revenue_period": "Revenue {{period}}",
    "table_label__order_sum_period": "Order Sum {{period}}",
    "table_label__unbilled_period": "Unbilled Revenue {{period}}",
    "table_label__billed_wo_credit_note_period": "Revenue excl. credit notes {{period}}",
    "table_label__margin_period": "GM {{period}}",
    "table_label__margin_pct_period": "GM % {{period}}",
    "table_label__period_YTD": "{{period}} YTD",
    "table_label__period_TODAY": "{{period}} Today",
    "table_label__period_YESTERDAY": "{{period}} Yesterday",
    "table_label__period_FULL_YEAR": "{{period}} Full Year",
    "table_label__period_LAST_WEEK": "{{period}} Last Week",
    "table_label__period_LAST_MONTH": "{{period}} Last Month",
    "table_label__period_LAST_QUARTER": "{{period}} 3 mo.",
    "table_label__period_TTM": "{{period}} 12 months",
    "table_label__period_CUSTOM_DATES": "{{from, datetime}}-{{to, datetime}}",
    "table_label__gross_margin_current": "GM",
    "table_label__gross_margin_percentage_current": "GM %",
    "table_label__gross_margin_last_period": "GM Previous Year",
    "table_label__gross_margin_percentage_last_period": "GM % Previous Year",
    "table_label__gross_margin_delta_amount": "Delta",
    "table_label__gross_margin_delta_percentage": "Delta %",
    "table_label__revenue_delta_amount": "Delta",
    "table_label__revenue_delta_percentage": "Delta %",
    "search_placeholder__STORAGE_LOCATION": "Search for storage locations",
    "search_placeholder__CLERK": "Search for clerks",
    "search_placeholder__SALES_REP": "Search for sales reps",
    "search_placeholder__CUSTOMER": "Search for customers",
    "search_placeholder__INDUSTRY": "Search for industries",
    "search_placeholder__PRODUCT": "Search for products ",
    "search_placeholder__PRODUCT_GROUP": "Search for product groups",
    "search_placeholder__SUPPLIER": "Search for suppliers",
    "search_placeholder__NORMALISED_CATEGORY": "Search for merchandise groups",
    "revenue_stats__title": "Sum of Revenue",
    "revenue_stats__title_order_sum": "Total Order Sum",
    "revenue_stats__sub_title_ytd": "Current year · {{range}} each year",
    "revenue_stats__sub_title_ttm": "Last 12 months · as of {{date}}",
    "total_summary__name": "Sum",
    "total_summary__name_tooltip": "Note: Select filters may cause double counting of revenue.",
    "explorer__export": "Export",
    "explorer__export_confirmation_title": "Tips for Handling Exported Data",
    "explorer__export_confirmation_content_1": "<strong>How to open the file:</strong><br/> Plato exports all data in an Excel file (.xlsx). You can open the file directly in Microsoft Excel, Google Sheets, or other spreadsheet applications.",
    "explorer__export_confirmation_content_2": "<strong>Filter Before Exporting:</strong><br/> Make sure to set filters like date range, category, or billing status before exporting, so you're only working with the most relevant data.",
    "explorer__export_confirmation_content_3": "<strong>Protect Sensitive Data:</strong><br/> If your export includes confidential metrics like gross margin, store and share the file securely. Always follow your company’s data protection guidelines.",
    "explorer__export_confirmation_accept": "Export",
    "explorer__export_no_data_title": "Nothing to export",
    "explorer__export_no_data_description": "No rows match the current filters.",
    "explorer__export_failed_title": "Export failed",
    "explorer__export_failed_description": "Please try again. If the problem persists, contact support."
}
